'use client';

import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface SkillRotatorProps {
  skills: string[];
}

export function SkillRotator({ skills }: SkillRotatorProps) {
  const [currentSkill, setCurrentSkill] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSkill((prev) => (prev + 1) % skills.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [skills.length]);

  return (
    <motion.div
      className="h-12 overflow-hidden mb-6"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.3 }}
    >
      <AnimatePresence mode="wait">
        <motion.div
          key={currentSkill}
          className="h-12"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="text-2xl md:text-3xl text-[#88ffff]">
            {skills[currentSkill]}
          </h2>
        </motion.div>
      </AnimatePresence>
    </motion.div>
  );
}